import { SvgIconComponent } from "@mui/icons-material";
import { WithTranslation } from "react-i18next";

export const SET_HREF_DATA = 'SET_HREF_DATA';
export const LOAD_PATH_SCHEME = 'LOAD_PATH_SCHEME';
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';

// --- DATA MODEL --- //

export type HrefData = {
    fullUrl: string,
    backendPath: string[],
    frontendPath: string[],
    query: {
        [key: string]: string|string[]|undefined|null
    }
}
export type NavigationTab = {
    id: string,
    title: string,
    component: React.JSXElementConstructor<NavigationTabProps>
}
export type NavigationTabs = {
    [id: string]: NavigationTab
}
export interface NavigationTabProps extends WithTranslation {
    tab: NavigationTab
}
export type NavigationPageProps = {
    tabPage: NavigationTab
}
export type NavigationPath = { 
    id: string,
    title: string, 
    url: string,
    Icon: SvgIconComponent,
    tabs: string[], 
    elevated?: boolean,
    currentTab?: string,
    exactUrl?: boolean,
    hideInMenu?: boolean
}
export type NavigationPaths = {
    [id: string]: NavigationPath
}
export type NavigationRedirect = {
    url: string,
    to: string,
    exactUrl?: boolean
}
export type NavigationRedirects = {
    [id: string]: NavigationRedirect
}

export type NavigationGroup = {
    id: string,
    title: string,
    children: string[]
}
export type NavigationGroups = {
    [id: string]: NavigationGroup
}
export interface NavigationState
{
    href: HrefData,
    subPages: NavigationPaths,
    groups: NavigationGroup[],
    currentSubPage: string
}

// --- ACTION MODEL --- //

interface SetHrefDataAction
{
    type: typeof SET_HREF_DATA;
    data: Location;
}

interface LoadPathSchemeAction
{
    type: typeof LOAD_PATH_SCHEME;
    scheme: NavigationPaths;
}

interface SetActiveTabAction
{
    type: typeof SET_ACTIVE_TAB;
    pageId: string;
    tabId: string;
}

export type NavigationAction = LoadPathSchemeAction | SetHrefDataAction | SetActiveTabAction;

// ------------------- //